import React from 'react'
import PropTypes from 'prop-types'
import { SeverityLevel } from '@microsoft/applicationinsights-web'

class AppInsightsErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true })

    const { appInsights } = this.props
    if (appInsights && typeof appInsights.trackException === 'function') {
      appInsights.trackException({
        error,
        exception: error,
        severityLevel: SeverityLevel.Error,
        properties: errorInfo,
      })
    }
  }

  render() {
    const { hasError } = this.state
    const { children, onError } = this.props

    return hasError ? React.createElement(onError) : children
  }
}

AppInsightsErrorBoundary.propTypes = {
  appInsights: PropTypes.shape({
    trackException: PropTypes.func,
  }),
  children: PropTypes.node.isRequired,
  onError: PropTypes.func.isRequired,
}

AppInsightsErrorBoundary.defaultProps = {
  appInsights: null,
}

export default AppInsightsErrorBoundary
